import { render, staticRenderFns } from "./HideableGoal.vue?vue&type=template&id=0dd690a4&scoped=true&"
import script from "./HideableGoal.vue?vue&type=script&lang=ts&"
export * from "./HideableGoal.vue?vue&type=script&lang=ts&"
import style0 from "./HideableGoal.vue?vue&type=style&index=0&id=0dd690a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd690a4",
  null
  
)

export default component.exports